import { render } from "./VariantsPopup.vue?vue&type=template&id=6a8880b3&ts=true"
import script from "./VariantsPopup.vue?vue&type=script&lang=ts"
export * from "./VariantsPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__